/**
 * Contact Form API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactFormRequest { 
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    subject: ContactFormRequest.SubjectEnum;
    message: string;
}
export namespace ContactFormRequest {
    export const SubjectEnum = {
        Consulting: 'CONSULTING',
        SoftwareDevelopment: 'SOFTWARE_DEVELOPMENT',
        IntegrationDevops: 'INTEGRATION_DEVOPS',
        Automation: 'AUTOMATION',
        ArtificialIntelligence: 'ARTIFICIAL_INTELLIGENCE',
        Inquiry: 'INQUIRY',
        Consultation: 'CONSULTATION',
        QuotationRequest: 'QUOTATION_REQUEST',
        Feedback: 'FEEDBACK',
        Other: 'OTHER'
    } as const;
    export type SubjectEnum = typeof SubjectEnum[keyof typeof SubjectEnum];
}


